import React from 'react'
import classes from 'classnames'

import styles from './Checkbox.module.scss'

interface CheckboxPropsType {
  checkboxClass?: string,
  checked: boolean,
  disabled?: boolean,
  label?: string,
  name?: string,
  onChange?: (e: object) => void,
  round?: boolean,
  value?: string,
}

const Checkbox = (props: CheckboxPropsType) => {
  const {
    checkboxClass = '',
    checked,
    disabled = false,
    label,
    name,
    onChange,
    round = false,
    value,
  } = props

  const checkboxClassName = classes(styles.checkboxComponentInput, {[styles.checkboxComponentInputRound]: round}, checkboxClass)

  return (
    <div className={styles.checkboxComponentContainer}>
      <input
        checked={checked}
        className={checkboxClassName}
        disabled={disabled}
        id={name}
        onChange={onChange}
        type='checkbox'
        value={value} />
        <label className={styles.checkboxComponentLabel} htmlFor={name}>{label}</label>
    </div>
  )
}

export default Checkbox;
